import { useEffect, useRef, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell } from "recharts";

const num = (d) => new Date(d + "T12:00:00").getDate();
const TICK = { fontSize: 11 };
const DOMAIN = [0, 100];
const RADIUS = [6, 6, 0, 0];
const fmtValue = (v) => `${v}%`;
const fmtLabel = (l) => new Date(l + "T12:00:00").toLocaleDateString("fr-FR");
const barColor = (p) => (p >= 80 ? "#16A34A" : p >= 50 ? "#F59E0B" : "#F97316");

export function DailyScoreChart({ days, height = 192 }) {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    const update = () => setWidth(Math.floor(el.getBoundingClientRect().width));
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ height }} className="w-full">
      {width > 0 && (
        <BarChart width={width} height={height} data={days}>
          <XAxis dataKey="date" tickFormatter={num} tick={TICK} interval={1} />
          <YAxis domain={DOMAIN} tick={TICK} width={28} />
          <Tooltip formatter={fmtValue} labelFormatter={fmtLabel} />
          <Bar dataKey="percent" radius={RADIUS}>
            {days.map((d) => <Cell key={d.date} fill={barColor(d.percent)} />)}
          </Bar>
        </BarChart>
      )}
    </div>
  );
}
